import { io } from "socket.io-client";
import Emitter from 'component-emitter';
import { GET_TOKEN, REFRESH_TOKEN } from "@/store/constants";
import store from "@/store";
export const AUTOMATION_SOCKET = {
  socket: null,
  connected: false,
  connecting: false,
  init(){
    try { 
      Emitter(this)
      window.AUTOMATION_SOCKET = this
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return this
    }
  },
  async onInvalidToken(message){
    if (["Token Expired","Invalid Token"].includes(message)) {
      await store.dispatch(REFRESH_TOKEN)
      this.socket.auth.token = store.getters[GET_TOKEN];
      this.socket.connect();
    }
  },
  connect(){
    if(this.connecting) return;
    try {
      this.connecting=true
      if(this.connected) throw new Error('Already Connected')
      this.socket = io(`${new URL(process.env.VUE_APP_AUTOMATION_URL).origin}`,{
        autoConnect: false,
        closeOnBeforeunload: true,
        reconnection: true,
        reconnectionDelayMax: 10000,
        reconnectionAttempts: 5,
        auth: {
          token: store.getters[GET_TOKEN]
        },
      });
      this.socket.on('connect',this.onConnect.bind(this))
      this.socket.on('disconnect',this.onDisconnect.bind(this))
      this.socket.on("connect_error", this.onConnectError.bind(this));
      this.socket.onAny(this.onAnyEvent.bind(this));
      this.socket.connect()
    } catch (ex) {
      console.log('AUTOMATION SOCKET connect error',ex)
      throw ex
    } finally {
      this.connecting=false
    }
  },
  disconnect(){
    this.socket?.disconnect?.()
  },
  onConnect(){
    console.log('AUTOMATION SOCKET connected')
    this.connected=true
    this.emit('connect')
  },
  async onConnectError(err){
    try {
      console.log('AUTOMATION SOCKET connect error',err,this.socket?.active)
      if(!this.socket?.active) {
        await this.onInvalidToken(err.message)
      }
    } catch (ex) {
      console.log('AUTOMATION SOCKET connect error exception',ex)
    }
  },
  onDisconnect(reason){
    console.log('AUTOMATION SOCKET disconnect',reason,this.socket?.active)
    this.connected=false
    if (!this.socket?.active) {
      if (reason=='io client disconnect') {
        this.socket=null
        this.socket?.off()
      }
    }
  },
  async onAnyEvent(event,...args){
    try {
      if(event=='error') {
        const [payload] = args
        await this.onInvalidToken(payload.message)
      } else {
        this.emit(event,...args)
      }
    } catch (ex) {
      console.log('AUTOMATION SOCKET any event exception',ex)
    }
  },
}